import React from 'react';

const AppFooter = () => (
  <footer className="footer">
    <span className="text-white">&copy; SurveyStud</span>
  </footer>
);

export default AppFooter;
